/** Only route-translated, fixed scope guidance may persist in a failed bubble. */
export const ASTRA_SCOPE_ERRORS = {
  astra_general_requires_client_chat: "This sample is not built yet. Use /codex-delegate-sample for its full build, or use /codex-delegate-2 in a client, finished sample, or Build chat. Your message was not sent.",
  astra_chat_scope_unavailable: "Could not check this chat’s Astra access. Your message was not sent. Please try again.",
  opus_creative_requires_sample_chat: "/opus-sample-creative only runs in a Sample chat. Your message was not sent.",
  recycle_requires_sample_chat: "/recycle-sample only runs in a Sample chat. Your message was not sent.",
  recycle_scope_unavailable: "Could not check this chat. Your message was not sent. Please try again.",
  compact_unavailable_in_operations: "Compact isn't available in Operations yet — Operations chats start fresh after idle, and the CLI auto-compacts near the 1M limit.",
  use_compact_action: "Use Compact without extra text. Your message was not sent.",
} as const;
export function visibleSendFailure(reason: string | undefined) {
  return Object.values(ASTRA_SCOPE_ERRORS).find(message => message === reason);
}
